import { Builder } from '@builder.io/sdk';
import { ArticlesList } from './ArticlesList';
import { ARTICLES_LIST_NAME } from './ArticlesList.types';

const ArticleListConfig = {
  name: ARTICLES_LIST_NAME,
  friendlyName: 'Articles List',
  description: 'A grid of articles with pagination.',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Read the latest news on Front Cover',
    },
    {
      name: 'showAs',
      type: 'string',
      enum: ['list', 'cards'],
      defaultValue: 'list',
    },
    {
      name: 'tagVariant',
      type: 'string',
      friendlyName: 'Tag Color',
      helperText: 'Color variant for category tags.',
      defaultValue: 'primary',
      enum: ['primary', 'secondary'],
    },
  ],
};

Builder.registerComponent(ArticlesList, ArticleListConfig);
